import ContactService from '@/services/ContactService.js';

export default {
    methods: {

        async getContactSingle() {
                
            ContactService.getContactSingle(this.accessToken, this.$route.params.id)
            .then(
                (contact => {
                this.$set(this, "contact", contact);
                }).bind(this)
            );
        },
    }
}